import {SOCKET_URL} from './settings';
class WebSocketService {
  static dispatchWS: any;
  static instance: any = null;
  callbacks: any = {
    messages: {},
    new_message: {},
    course_info: {},
    coordinates_info: {},
  };
  socketRef: any;
  private reconnectAttempts = 0;
  private reconnectTimer: ReturnType<typeof setTimeout> | null = null;
  private intendedDisconnect = false;
  private static readonly MAX_RECONNECT = 5;
  static getInstance() {
    if (!WebSocketService.instance) {
      WebSocketService.instance = new WebSocketService();
    }
    return WebSocketService.instance;
  }

  constructor() {
    this.socketRef = null;
  }

  connect(chatUrl: any) {
    if (this.socketRef != null && this.socketRef.readyState <= 1) return;
    this.intendedDisconnect = false;
    const path = `${SOCKET_URL}/ws/chat/${chatUrl}/`;
    // #region agent log
    fetch('http://localhost:7752/ingest/4bc185c9-2f28-4a92-b4d9-447a09d7411e',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1a5d16'},body:JSON.stringify({sessionId:'1a5d16',runId:'post-fix',hypothesisId:'A',location:'websocket.ts:connect',message:'ws connect',data:{path,attempt:this.reconnectAttempts},timestamp:Date.now()})}).catch(()=>{});
    // #endregion
    this.socketRef = new WebSocket(path);
    this.socketRef.onopen = () => {
      this.reconnectAttempts = 0;
      console.log('WebSocket open');
      // #region agent log
      fetch('http://localhost:7752/ingest/4bc185c9-2f28-4a92-b4d9-447a09d7411e',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1a5d16'},body:JSON.stringify({sessionId:'1a5d16',runId:'post-fix',hypothesisId:'B',location:'websocket.ts:onopen',message:'ws open',data:{path},timestamp:Date.now()})}).catch(()=>{});
      // #endregion
    };
    this.socketRef.onmessage = (e: {data: any}) => {
      this.socketNewMessage(e.data);
    };
    this.socketRef.onerror = (e: {message: any}) => {
      console.log(e.message);
    };
    this.socketRef.onclose = (code: any, reason: any) => {
      console.log("WebSocket closed let's reopen", code, reason);
      this.socketRef = null;
      if (this.intendedDisconnect) return;
      if (this.reconnectAttempts >= WebSocketService.MAX_RECONNECT) {
        console.error('WebSocket reconnect limit reached');
        return;
      }
      const delay = Math.min(1000 * 2 ** this.reconnectAttempts, 15000);
      this.reconnectAttempts += 1;
      this.reconnectTimer = setTimeout(() => this.connect(chatUrl), delay);
    };
  }

  disconnect() {
    this.intendedDisconnect = true;
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.socketRef) {
      this.socketRef.close();
      this.socketRef = null;
    }
  }

  socketNewMessage(data: any) {
    const parsedData = JSON.parse(data);
    const command = parsedData.command;
    if (Object.keys(this.callbacks).length === 0) {
      return;
    }
    if (command === 'messages') {
      this.callbacks[command](parsedData.messages);
    }
    if (command === 'new_message') {
      this.callbacks[command](parsedData.message);
    }
    if (command === 'course_info') {
      this.callbacks[command](parsedData.message);
    }
    if (command === 'coordinates_info') {
      this.callbacks[command](parsedData.message);
    }
  }

  fetchMessages(username: string, chatId: number) {
    this.sendMessage({
      command: 'fetch_messages',
      username: username,
      chatId: chatId,
    });
  }

  newChatMessage(message: any) {
    this.sendMessage({
      command: 'new_message',
      from: message.from,
      message: message.content,
      chatId: message.chatId,
    });
  }

  getCousreInfo(message: any) {
    this.sendMessage({
      command: 'course_info',
      from: message.from,
      message: message.courseCategory,
      chatId: message.chatId,
    });
  }

  sendCoordinate(message: any) {
    this.sendMessage({
      command: 'coordinates_info',
      x: message.x,
      y: message.y,
      z: message.z,
      from: message.from,
    });
  }

  addCallbacks(
    messagesCallback: any,
    newMessageCallback: any,
    courseInfoCallback: any,
  ) {
    this.callbacks['messages'] = messagesCallback;
    this.callbacks['new_message'] = newMessageCallback;
    this.callbacks['course_info'] = courseInfoCallback;
  }

  addCoordinateCallbacks(coordinatesInfoCallback: any) {
    this.callbacks['coordinates_info'] = coordinatesInfoCallback;
  }

  sendMessage(data: any) {
    try {
      this.socketRef.send(JSON.stringify({...data}));
    } catch (err: any) {
      console.log(err);
    }
  }

  state() {
    return this.socketRef?.readyState;
  }
}

const WebSocketInstance = WebSocketService.getInstance();

export default WebSocketInstance;
